<template>
  <swiper
    v-if="hasCountry"
    :speed="swiperSet.speed"
    :pagination="swiperSet.pagination"
    :navigation="swiperSet.navigation"
    :modules="swiperSet.modules"
    :autoplay="swiperSet.autoplay"
    :loop="swiperSet.loop"
    class="mySwiper"
  >
    <!-- Кнопки переключения слайдов "назад" и "вперёд" -->
    <div
      ref="prev"
      class="swiper-button swiper-button-prev"
    >
      <IconChevronLeft />
    </div>
    <div
      ref="next"
      class="swiper-button swiper-button-next"
    >
      <IconChevronRight />
    </div>
    <swiper-slide v-if="topupIsEnabled">
      <HomeSliderBanner :info="bannerStore.bannerPromo" />
    </swiper-slide>
    <swiper-slide v-if="exchangerEventIsEnabled">
      <HomeSliderBanner :info="bannerStore.bannerPoseidon" />
    </swiper-slide>
    <swiper-slide v-if="bossBattleIsEnabled">
      <HomeSliderBanner :info="bannerStore.bannerMegalodon" />
    </swiper-slide>
    <swiper-slide>
      <HomeSliderBanner :info="bannerStore.bannerUpgrade" />
    </swiper-slide>
    <swiper-slide v-if="isNotRoblox">
      <HomeSliderBanner :info="bannerStore.bannerContracts" />
    </swiper-slide>
    <swiper-slide v-if="bullpassIsAvailable">
      <HomeSliderBanner :info="bannerStore.bannerBullpass" />
    </swiper-slide>
    <swiper-slide v-if="!coreStore.isUserIndia">
      <HomeSliderBanner :info="bannerStore.bannerTelegram" />
    </swiper-slide>
  </swiper>
</template>

<script lang="ts" setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Navigation, Pagination } from "swiper";
import type { SwiperOptions } from "swiper";
import HomeSliderBanner from "~/components/Home/HomeSlider/HomeSliderBanner.vue";

const prev = ref<HTMLElement | null>(null);
const next = ref<HTMLElement | null>(null);

const swiperSet: SwiperOptions = reactive({
  speed: 600,
  pagination: {
    clickable: true,
  },
  navigation: {
    prevEl: prev,
    nextEl: next,
  },
  modules: [Autoplay, Pagination, Navigation],
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
  },
  loop: true,
});

const platform = usePlatform();
const coreStore = useCoreStore();
const bannerStore = useBannersStore();
const exchangerEventIsEnabled = computed(() => {
  const platform = usePlatform();
  if (!platform.is.genshin && !platform.is.roblox) {
    return coreStore.showExchanger;
  } else {
    return false;
  }
});

const bullpassIsAvailable = computed(() => {
  const platform = usePlatform();
  return (
    platform.code !== "genshin" &&
    platform.code !== "roblox" &&
    !platform.is.free_fire
  );
});
const isNotRoblox = computed(() => !platform?.is.roblox);
const topupIsEnabled = useFlag("topupBanner");
const bossBattleIsEnabled = computed(() => {
  const platform = usePlatform();
  if (!platform.is.genshin && !platform.is.roblox && !platform.is.free_fire) {
    return coreStore.showBossBattle;
  } else {
    return false;
  }
});

const hasCountry = computed(() => {
  return coreStore.userCountry !== null;
});
</script>

<style lang="scss" scoped>
// Точечные настройки для Свайпера
.swiper {
  width: 100%;
  height: 100%;
  border-radius: 32px;
  transition: box-shadow 0.4s linear;
  :deep(.swiper-slide) {
    overflow: hidden;
    border-radius: 32px;
  }
  @media screen and (max-width: $tablet-banner-filter) {
    border-radius: 20px;
    :deep(.swiper-slide) {
      border-radius: 20px;
    }
  }
  @media screen and (max-width: 800px) {
    height: 420px;
    width: 430px;
  }
  @media screen and (max-width: 420px) {
    width: 100%;
    .slide {
      width: 99%;
      overflow: hidden;
    }
    :deep(.swiper-wrapper) {
      gap: 0.5px;
    }
  }

  // Кнопки переключения
  .swiper-button {
    position: absolute;
    bottom: 29px;
    width: 36px;
    height: 36px;
    z-index: 10;
    cursor: pointer;
    left: unset;
    top: auto;
    border-radius: 14px;
    background: var(--general-transparent-light-10);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      width: 20px;
      height: 20px;
      fill: var(--general-white);
    }

    &:after {
      content: none;
    }

    @media screen and (max-width: 834px) {
      bottom: 37px;
    }

    @media screen and (max-width: 800px) {
      display: none;
    }
  }
  .swiper-button-next {
    right: 45px;
    .arrow-right {
      background-image: url("~/assets/right.svg");
    }
    @media screen and (max-width: 834px) {
      right: 27px;
    }
  }
  .swiper-button-prev {
    right: 91px;
    .arrow-left {
      background-image: url("~/assets/left.svg");
    }
    @media screen and (max-width: 834px) {
      right: 73px;
    }
  }
  :deep(.swiper-pagination) {
    top: 20px;
    left: auto;
    right: 32px;
    width: auto;
    height: 30px;
    .swiper-pagination-bullet {
      background: var(--general-white);
      transition: all 0.2s linear;
    }
    .swiper-pagination-bullet-active {
      background-color: var(--general-white);
      width: 20px;
      height: 8px;
      border-radius: 100px;
    }
    @media screen and (max-width: $tablet-banner-filter) {
      top: 10px;
      right: 20px;
    }
    @media screen and (max-width: 800px) {
      top: 20px;
      right: auto;
      width: 100%;
    }
  }

  // Блок слайда
  .slide {
    height: 320px;
    padding: 32px;
    border-radius: 32px;

    @media screen and (max-width: 1280px) {
      padding: 36px;
    }

    @media screen and (max-width: $tablet-banner-filter) {
      height: 280px;
      padding: 20px;
      border-radius: 20px;
    }

    @media screen and (max-width: 800px) {
      height: 420px;
      padding: 0;
    }

    .parallax-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 130%;
      height: 100%;
      -webkit-background-size: cover;
      background-size: cover;
      background-position: center;
    }
  }
}
</style>
